<template>
    <!-- Interface principale -->
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">

        <!-- Header fixe -->
        <div class="sticky top-0 z-20 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 shadow-sm">
            <div class="container mx-auto px-4 py-3">
                <div class="flex items-center justify-between">
                    <!-- Logo et informations de base -->
                    <div class="flex items-center gap-4">
                        <div class="flex items-center gap-2">
                            <div class="w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
                                <i class="fas fa-cash-register text-white text-lg"></i>
                            </div>
                            <div>
                                <h1 class="font-bold text-gray-800 dark:text-white">Caisse Resto</h1>
                                <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                                    <span>{{ Items.datedoc }}</span>
                                    <span v-if="Items.docnum" class="font-medium text-blue-600 dark:text-blue-400">#{{ Items.docnum }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Informations de caisse -->
                    <div class="flex items-center gap-4">
                        <div class="hidden md:block bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-lg shadow">
                            <div class="flex items-center gap-2">
                                <i class="fas fa-wallet"></i>
                                <div>
                                    <p class="text-xs opacity-90">Solde caisse</p>
                                    <p class="font-bold">{{ formatNumber($store.state.montantencaisse) }}</p>
                                </div>
                            </div>
                        </div>

                        <button @click="toggleTheme"
                                class="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                            <i :class="isDarkMode ? 'fas fa-sun text-yellow-500' : 'fas fa-moon text-gray-600'"></i>
                        </button>

                        <button @click="toggleQuickMenu"
                                class="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors relative">
                            <i class="fas fa-ellipsis-v"></i>
                            <span v-if="nbrefactureenattante > 0"
                                  class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                {{ nbrefactureenattante }}
              </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Menu rapide -->
        <div v-if="quickMenuVisible"
             class="fixed top-16 right-4 z-30 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 w-64">
            <div class="p-2">
                <a @click="btnupdatefactureselected"
                   class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors">
                    <div class="w-8 h-8 rounded-lg bg-orange-100 dark:bg-orange-900 flex items-center justify-center">
                        <i class="fas fa-clock text-orange-600 dark:text-orange-300"></i>
                    </div>
                    <div class="flex-1">
                        <p class="font-medium text-gray-800 dark:text-white">Factures en attente</p>
                        <p class="text-xs text-gray-500">{{ nbrefactureenattante }} en attente</p>
                    </div>
                </a>

                <a @click="btnmodalpointdelacaisse5"
                   class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors">
                    <div class="w-8 h-8 rounded-lg bg-purple-100 dark:bg-purple-900 flex items-center justify-center">
                        <i class="fas fa-chart-pie text-purple-600 dark:text-purple-300"></i>
                    </div>
                    <div class="flex-1">
                        <p class="font-medium text-gray-800 dark:text-white">Point de caisse</p>
                        <p class="text-xs text-gray-500">État des ventes</p>
                    </div>
                </a>

                <a @click="note"
                   class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors">
                    <div class="w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                        <i class="fas fa-print text-blue-600 dark:text-blue-300"></i>
                    </div>
                    <p class="font-medium text-gray-800 dark:text-white">Imprimer note</p>
                </a>

                <div class="border-t border-gray-200 dark:border-gray-700 my-2"></div>

                <a @click="newinvoice"
                   class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors">
                    <div class="w-8 h-8 rounded-lg bg-green-100 dark:bg-green-900 flex items-center justify-center">
                        <i class="fas fa-plus text-green-600 dark:text-green-300"></i>
                    </div>
                    <p class="font-medium text-gray-800 dark:text-white">Nouvelle vente</p>
                </a>
            </div>
        </div>

        <!-- Barre d'information contextuelle -->
        <div class="bg-gray-100 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 py-2">
            <div class="container mx-auto px-4">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-6 overflow-x-auto pb-2">
                        <!-- Serveur -->
                        <div class="flex items-center gap-2">
                            <div class="w-6 h-6 rounded-full bg-blue-500/20 flex items-center justify-center">
                                <i class="fas fa-user text-blue-600 dark:text-blue-400 text-xs"></i>
                            </div>
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
                {{ currentServer?.name || 'Non assigné' }}
              </span>
                        </div>

                        <!-- Table -->
                        <div class="flex items-center gap-2">
                            <div class="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
                                <i class="fas fa-table text-green-600 dark:text-green-400 text-xs"></i>
                            </div>
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
                {{ currentTable?.name || 'Non assignée' }}
              </span>
                        </div>

                        <!-- Client -->
                        <div class="flex items-center gap-2">
                            <div class="w-6 h-6 rounded-full bg-purple-500/20 flex items-center justify-center">
                                <i class="fas fa-users text-purple-600 dark:text-purple-400 text-xs"></i>
                            </div>
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap truncate max-w-[150px]">
                {{ Items.jsonv.client || 'À saisir' }}
              </span>
                        </div>

                        <!-- Règlement -->
                        <div class="flex items-center gap-2">
                            <div class="w-6 h-6 rounded-full bg-orange-500/20 flex items-center justify-center">
                                <i class="fas fa-credit-card text-orange-600 dark:text-orange-400 text-xs"></i>
                            </div>
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
                {{ Items.jsonv.modereglement?.name || 'À choisir' }}
              </span>
                        </div>
                    </div>

                    <!-- Total du panier -->
                    <div class="hidden md:flex items-center gap-2">
                        <span class="text-sm text-gray-500 dark:text-gray-400">Total :</span>
                        <span class="text-lg font-bold text-gray-800 dark:text-white">
              {{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }}
            </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Contenu principal -->
        <div class="container mx-auto px-4 py-6">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <!-- Colonne gauche : Catalogue produits -->
                <div class="lg:col-span-2 space-y-6">
                    <!-- Barre de recherche et filtres -->
                    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
                        <div class="flex flex-col sm:flex-row gap-4">
                            <div class="flex-1">
                                <div class="relative">
                                    <input v-model="searchword"
                                           @keyup.enter="focusFirstProduct"
                                           type="text"
                                           placeholder="Rechercher un produit..."
                                           class="w-full pl-10 pr-4 py-3 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 outline-none transition text-gray-800 dark:text-white">
                                    <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                </div>
                            </div>

                            <div class="flex gap-2 overflow-x-auto pb-1">
                                <button @click="selectedcatalogue = ''"
                                        :class="selectedcatalogue === '' ? 'bg-blue-500 text-white shadow-sm' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'"
                                        class="px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200">
                                    Tous
                                </button>
                                <button v-for="(line, index) in datatablearticlegroupe" :key="index"
                                        @click="selectedcatalogue = index"
                                        :class="selectedcatalogue === index ? 'bg-blue-500 text-white shadow-sm' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'"
                                        class="px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-200">
                                    {{ index }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Grille des produits -->
                    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                        <div class="p-4 border-b border-gray-200 dark:border-gray-700">
                            <div class="flex items-center justify-between">
                                <h3 class="font-bold text-gray-800 dark:text-white">Produits</h3>
                                <span class="text-sm text-gray-500 dark:text-gray-400">
                  {{ filterdatatable.length }} produits
                </span>
                            </div>
                        </div>

                        <div class="h-[500px] overflow-y-auto p-4">
                            <div v-if="filterdatatable.length === 0"
                                 class="h-full flex flex-col items-center justify-center text-gray-400 py-12">
                                <i class="fas fa-search text-5xl mb-4 opacity-20"></i>
                                <p class="text-lg mb-2">Aucun produit trouvé</p>
                                <p class="text-sm text-center">Modifiez vos critères de recherche</p>
                            </div>

                            <div v-else class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                <div v-for="(datavalue, j) of filterdatatable" :key="j"
                                     @click="selectionitemforfacturation(datavalue)"
                                     @dblclick="quickAddToCart(datavalue)"
                                     class="group cursor-pointer">
                                    <div class="bg-gradient-to-br from-gray-50 to-white dark:from-gray-800 dark:to-gray-700 rounded-xl p-4 hover:shadow-lg transition-all duration-300 border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 h-full">
                                        <!-- Image produit -->
                                        <div class="w-full h-32 bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg mb-3 flex items-center justify-center relative overflow-hidden">
                                            <i class="fas fa-box text-4xl text-blue-400 dark:text-blue-300"></i>
                                            <!-- Badge stock faible -->
                                            <div v-if="datavalue.rstck !== null && parseFloat(datavalue.rstck) < 10"
                                                 class="absolute top-2 right-2 px-2 py-1 bg-red-500 text-white text-xs rounded-full">
                                                {{ datavalue.rstck }}
                                            </div>
                                        </div>

                                        <!-- Informations produit -->
                                        <div class="flex flex-col h-[100px]">
                                            <h4 class="font-semibold text-gray-800 dark:text-white line-clamp-2 mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                                                {{ datavalue.libelle }}
                                            </h4>

                                            <div class="mt-auto">
                                                <div class="flex items-center justify-between">
                          <span class="text-lg font-bold text-gray-900 dark:text-white">
                            {{ !isNormalisationEtat ? formatNumber(datavalue.pu) : formatNumber(datavalue.pu7) }}
                          </span>

                                                    <button class="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transform group-hover:scale-110 transition-all duration-200 shadow-lg hover:shadow-xl hover:bg-blue-600">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                </div>

                                                <!-- Référence -->
                                                <p v-if="datavalue.reference" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                    {{ datavalue.reference }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <div v-if="pages.length > 1" class="p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center gap-4">
                                    <div class="text-sm text-gray-500 dark:text-gray-400">
                                        Page {{ page }} sur {{ pages.length }}
                                    </div>

                                    <select v-model="perPage" @change="page = 1"
                                            class="text-sm border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-1 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                        <option value="20">20 par page</option>
                                        <option value="50">50 par page</option>
                                        <option value="100">100 par page</option>
                                        <option value="200">200 par page</option>
                                    </select>
                                </div>

                                <div class="flex items-center gap-2">
                                    <button @click="page--"
                                            :disabled="page <= 1"
                                            class="w-9 h-9 rounded-lg flex items-center justify-center bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
                                        <i class="fas fa-chevron-left text-sm"></i>
                                    </button>

                                    <div class="flex items-center gap-1">
                                        <button v-for="p in displayedPages" :key="p"
                                                @click="typeof p === 'number' ? page = p : null"
                                                :class="[
                              p === page
                                ? 'bg-blue-500 text-white border-blue-500'
                                : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600',
                              'w-9 h-9 rounded-lg flex items-center justify-center border transition-colors'
                            ]">
                                            {{ p }}
                                        </button>
                                    </div>

                                    <button @click="page++"
                                            :disabled="page >= pages.length"
                                            class="w-9 h-9 rounded-lg flex items-center justify-center bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
                                        <i class="fas fa-chevron-right text-sm"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Colonne droite : Panier -->
                <div class="lg:col-span-1">
                    <div class="sticky top-24">
                        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 flex flex-col h-[calc(100vh-180px)]">
                            <!-- En-tête panier -->
                            <div class="p-4 border-b border-gray-200 dark:border-gray-700">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center gap-3">
                                        <div class="w-10 h-10 rounded-lg bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center">
                                            <i class="fas fa-shopping-cart text-white"></i>
                                        </div>
                                        <div>
                                            <h3 class="font-bold text-gray-800 dark:text-white">Panier</h3>
                                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                                {{ listedatatable.length }} article(s)
                                            </p>
                                        </div>
                                    </div>

                                    <button @click="clearCart"
                                            v-if="listedatatable.length > 0"
                                            class="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Liste des articles -->
                            <div class="flex-1 overflow-y-auto p-4">
                                <div v-if="listedatatable.length === 0"
                                     class="h-full flex flex-col items-center justify-center text-gray-400 py-12">
                                    <i class="fas fa-shopping-basket text-5xl mb-4 opacity-20"></i>
                                    <p class="text-lg mb-2">Panier vide</p>
                                    <p class="text-sm text-center px-4">Cliquez sur un produit pour l'ajouter au panier</p>
                                </div>

                                <div v-else class="space-y-3">
                                    <div v-for="(datavalue, index) in listedatatable" :key="index"
                                         :class="[
                         'rounded-lg p-3 transition-all duration-200',
                         datavalue.etatline === 2
                           ? 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800'
                           : datavalue.etatline === 1
                           ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'
                           : 'bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600'
                       ]">
                                        <!-- En-tête article -->
                                        <div class="flex items-start justify-between mb-2">
                                            <div class="flex-1 min-w-0">
                                                <h4 class="font-medium text-gray-800 dark:text-white truncate">
                                                    {{ datavalue.article.libelle }}
                                                </h4>
                                                <p v-if="datavalue.autredesignation"
                                                   class="text-xs text-gray-500 dark:text-gray-400 italic truncate">
                                                    {{ datavalue.autredesignation }}
                                                </p>
                                            </div>

                                            <div class="flex items-center gap-1 ml-2">
                                                <button @click="btnupdateqteitem(datavalue)"
                                                        class="w-7 h-7 rounded bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400 flex items-center justify-center hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors">
                                                    <i class="fas fa-edit text-xs"></i>
                                                </button>
                                                <button @click="deleteItemArticle(datavalue)"
                                                        class="w-7 h-7 rounded bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-400 flex items-center justify-center hover:bg-red-200 dark:hover:bg-red-800 transition-colors">
                                                    <i class="fas fa-trash text-xs"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Détails article -->
                                        <div class="flex items-center justify-between">
                                            <div class="text-sm">
                                                <div class="flex items-center gap-3">
                                                    <span class="text-gray-600 dark:text-gray-300">{{ datavalue.qtite }} ×</span>
                                                    <span class="font-medium text-gray-800 dark:text-white">{{ datavalue.pu }}</span>
                                                    <span v-if="datavalue.remise > 0"
                                                          class="text-red-500 dark:text-red-400 text-xs bg-red-100 dark:bg-red-900 px-1 rounded">
                            -{{ datavalue.remise }}
                          </span>
                                                </div>
                                            </div>

                                            <div class="text-right">
                                                <div class="font-bold text-gray-800 dark:text-white">
                                                    {{ currencyFormatDE(datavalue.calmtntht) }}
                                                </div>
                                                <div v-if="datavalue.etatline === 2"
                                                     class="text-xs text-red-500 mt-1 flex items-center gap-1">
                                                    <i class="fas fa-exclamation-triangle"></i>
                                                    <span>Erreur</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Totaux et paiement -->
                            <div v-if="listedatatable.length > 0"
                                 class="p-4 border-t border-gray-200 dark:border-gray-700 space-y-4 bg-gray-50 dark:bg-gray-800/50">
                                <!-- Détails des totaux -->
                                <div class="space-y-2">
                                    <div class="flex justify-between text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Sous-total</span>
                                        <span class="font-medium text-gray-800 dark:text-white">{{ currencyFormatDE(Items.mtnt.doccalmtnttotalht) }}</span>
                                    </div>

                                    <div v-if="Items.mtnt.docmtntremise > 0" class="flex justify-between text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Remise</span>
                                        <span class="font-medium text-red-500 dark:text-red-400">-{{ currencyFormatDE(Items.mtnt.docmtntremise) }}</span>
                                    </div>

                                    <div class="flex justify-between text-lg pt-2 border-t border-gray-300 dark:border-gray-600">
                                        <span class="font-bold text-gray-800 dark:text-white">Total</span>
                                        <span class="font-bold text-blue-600 dark:text-blue-400">{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }}</span>
                                    </div>
                                </div>

                                <!-- Montant reçu -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        Montant reçu
                                    </label>
                                    <div class="relative">
                                        <input v-model="Items.jsonotherdonne.montantrecu"
                                               @keyup.enter="saveItems"
                                               type="number"
                                               min="0"
                                               step="100"
                                               class="w-full pl-10 pr-4 py-3 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 outline-none transition text-right font-semibold">
                                        <i class="fas fa-money-bill-wave absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                    </div>

                                    <!-- Suggestions rapides -->
                                    <div v-if="Items.mtnt.docmtnttotalttc > 0" class="flex flex-wrap gap-2 mt-3">
                                        <button v-for="suggestion in getAmountSuggestions()" :key="suggestion"
                                                @click="Items.jsonotherdonne.montantrecu = suggestion"
                                                class="px-3 py-1.5 text-sm bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 rounded-lg transition-colors">
                                            {{ currencyFormatDE(suggestion) }}
                                        </button>
                                    </div>
                                </div>

                                <!-- Reliquat -->
                                <div v-if="Items.jsonotherdonne.montantrecu > 0"
                                     class="p-3 rounded-lg"
                                     :class="reliquat >= 0 ? 'bg-green-50 dark:bg-green-900/20' : 'bg-red-50 dark:bg-red-900/20'">
                                    <div class="flex justify-between items-center">
                    <span class="font-medium" :class="reliquat >= 0 ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'">
                      <i :class="reliquat >= 0 ? 'fas fa-coins' : 'fas fa-exclamation-circle'" class="mr-2"></i>
                      {{ reliquat >= 0 ? 'Monnaie à rendre' : 'Montant manquant' }}
                    </span>
                                        <span class="text-lg font-bold" :class="reliquat >= 0 ? 'text-green-600 dark:text-green-300' : 'text-red-600 dark:text-red-300'">
                      {{ currencyFormatDE(Math.abs(reliquat)) }}
                    </span>
                                    </div>
                                </div>

                                <!-- Boutons d'action -->
                                <div class="grid grid-cols-2 gap-3">
                                    <button @click="btnwidgetreglement"
                                            class="py-3 bg-gradient-to-r from-orange-500 to-amber-600 text-white rounded-lg font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
                                        <i class="fas fa-credit-card"></i>
                                        <span>Règlement</span>
                                    </button>

                                    <button @click="saveItems"
                                            :disabled="compteprocess > 0 || listedatatable.length === 0"
                                            :class="compteprocess > 0 || listedatatable.length === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600 active:scale-95'"
                                            class="py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg font-bold flex items-center justify-center gap-3 transition-all duration-200 shadow-lg hover:shadow-xl">
                                        <i class="fas fa-check-circle"></i>
                                        <span>Valider</span>
                                        <span v-if="compteprocess > 0"
                                              class="px-2 py-1 bg-white/20 rounded-full text-xs">
                      {{ compteprocess }}
                    </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Boutons flottants -->
        <div class="fixed right-4 bottom-4 md:bottom-6 z-30 flex flex-col gap-3">
            <!-- Bouton pour clients -->
            <div class="relative group">
                <button @click="btnwidgetclient"
                        class="w-14 h-14 rounded-full bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-users text-lg"></i>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        {{ Items.jsonv.client || 'Gérer clients' }}
                    </div>
                </div>
            </div>

            <!-- Bouton pour serveur -->
            <div class="relative group">
                <button @click="btnwidgetserveur"
                        :class="currentServer?.name ? 'bg-gradient-to-r from-blue-500 to-cyan-600' : 'bg-gradient-to-r from-gray-500 to-gray-600'"
                        class="w-14 h-14 rounded-full text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-user-friends text-lg"></i>
                    <div v-if="currentServer?.name"
                         class="absolute -top-1 -right-1 w-6 h-6 bg-green-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-white dark:border-gray-800">
                        <i class="fas fa-check"></i>
                    </div>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        {{ currentServer?.name || 'Sélectionner serveur' }}
                    </div>
                </div>
            </div>

            <!-- Bouton pour tables -->
            <div class="relative group">
                <button @click="btnwidgettable"
                        :class="currentTable?.name ? 'bg-gradient-to-r from-green-500 to-teal-600' : 'bg-gradient-to-r from-gray-500 to-gray-600'"
                        class="w-14 h-14 rounded-full text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-table text-lg"></i>
                    <div v-if="currentTable?.name"
                         class="absolute -top-1 -right-1 w-6 h-6 bg-green-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-white dark:border-gray-800">
                        {{ currentTable.name.substring(0, 3) }}
                    </div>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        {{ currentTable?.name || 'Sélectionner table' }}
                    </div>
                </div>
            </div>

            <!-- Bouton pour règlements -->
            <div class="relative group">
                <button @click="btnwidgetreglement"
                        :class="Items.jsonv.modereglement ? 'bg-gradient-to-r from-orange-500 to-amber-600' : 'bg-gradient-to-r from-gray-500 to-gray-600'"
                        class="w-14 h-14 rounded-full text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-credit-card text-lg"></i>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        {{ Items.jsonv.modereglement?.name || 'Mode de règlement' }}
                    </div>
                </div>
            </div>

            <!-- Bouton pour nouveau client -->
            <div class="relative group">
                <button @click="openNewClientModal"
                        class="w-14 h-14 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-user-plus text-lg"></i>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        Nouveau client
                    </div>
                </div>
            </div>

            <!-- Bouton pour nouveau produit -->
            <div class="relative group md:hidden">
                <button @click="scrollToProducts"
                        class="w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-xl flex items-center justify-center hover:shadow-2xl hover:scale-105 active:scale-95 transition-all duration-200">
                    <i class="fas fa-box text-lg"></i>
                </button>
                <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    <div class="bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap">
                        Voir produits
                    </div>
                </div>
            </div>
        </div>

        <!-- Modals -->
        <!-- Modal Client -->
        <div v-if="clientModalVisible"
             class="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
            <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 scale-100 opacity-100">
                <div class="p-6">
                    <div class="flex items-center justify-between mb-6">
                        <h3 class="text-xl font-bold text-gray-800 dark:text-white">Gestion des clients</h3>
                        <button @click="clientModalVisible = false"
                                class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
                            <i class="fas fa-times text-xl"></i>
                        </button>
                    </div>

                    <!-- Recherche client -->
                    <div class="mb-6">
                        <div class="relative">
                            <input v-model="clientSearch"
                                   type="text"
                                   placeholder="Rechercher un client..."
                                   class="w-full pl-10 pr-4 py-3 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
                            <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                        </div>
                    </div>

                    <!-- Liste des clients -->
                    <div class="mb-6 max-h-60 overflow-y-auto">
                        <div v-if="!otherdatatable.beneficiairecl || otherdatatable.beneficiairecl.length === 0"
                             class="text-center py-8 text-gray-500">
                            <i class="fas fa-users text-4xl mb-3 opacity-20"></i>
                            <p>Aucun client enregistré</p>
                        </div>

                        <div v-else class="space-y-2">
                            <div v-for="client in filteredClients" :key="client.id"
                                 @click="selectClient(client)"
                                 :class="[
                     'p-3 rounded-lg border cursor-pointer transition-all duration-200',
                     Items.jsonv.client === client.name
                       ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                       : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600'
                   ]">
                                <div class="flex items-center justify-between">
                                    <div class="flex-1 min-w-0">
                                        <p class="font-medium text-gray-800 dark:text-white truncate">{{ client.name }}</p>
                                        <div class="flex items-center gap-3 mt-1 text-xs text-gray-500">
                                            <span v-if="client.ifu">IFU: {{ client.ifu }}</span>
                                            <span v-if="client.phone">{{ client.phone }}</span>
                                        </div>
                                    </div>
                                    <i v-if="Items.jsonv.client === client.name"
                                       class="fas fa-check-circle text-green-500 ml-2"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Formulaire nouveau client -->
                    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Nom du client *
                                </label>
                                <input v-model="newClient.name"
                                       type="text"
                                       placeholder="Nom complet"
                                       class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
                            </div>

                            <div class="grid grid-cols-2 gap-3">
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        Téléphone
                                    </label>
                                    <input v-model="newClient.phone"
                                           type="tel"
                                           placeholder="00000000"
                                           class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
                                </div>

                                <div>
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        IFU
                                    </label>
                                    <input v-model="newClient.ifu"
                                           type="text"
                                           placeholder="IFU"
                                           class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
                                </div>
                            </div>
                        </div>

                        <!-- Boutons -->
                        <div class="flex gap-3 mt-6">
                            <button @click="clientModalVisible = false"
                                    class="flex-1 py-3 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                                Annuler
                            </button>
                            <button @click="addNewClient"
                                    :disabled="!newClient.name.trim()"
                                    :class="!newClient.name.trim() ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-600'"
                                    class="flex-1 py-3 bg-blue-500 text-white rounded-lg transition-colors">
                                Ajouter client
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Règlement -->
        <div v-if="reglementModalVisible"
             class="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
            <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
                <div class="p-6">
                    <div class="flex items-center justify-between mb-6">
                        <h3 class="text-xl font-bold text-gray-800 dark:text-white">Paiement</h3>
                        <button @click="reglementModalVisible = false"
                                class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
                            <i class="fas fa-times text-xl"></i>
                        </button>
                    </div>

                    <!-- Montant total -->
                    <div class="mb-6 p-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl text-white">
                        <div class="text-center">
                            <p class="text-sm opacity-90">Total à payer</p>
                            <p class="text-3xl font-bold">{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }}</p>
                        </div>
                    </div>

                    <!-- Modes de règlement -->
                    <div class="mb-6">
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Mode de règlement</p>
                        <div class="grid grid-cols-2 gap-3">
                            <button v-for="mode in otherdatatable.modedereglement" :key="mode.id"
                                    @click="selectReglementMode(mode)"
                                    :class="[
                        'p-4 rounded-xl border-2 transition-all duration-200',
                        Items.jsonv.modereglement?.id === mode.id
                          ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 scale-95'
                          : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 hover:scale-95'
                      ]">
                                <div class="flex flex-col items-center gap-2">
                                    <i :class="getReglementIcon(mode.name)" class="text-2xl"></i>
                                    <span class="font-medium">{{ mode.name }}</span>
                                </div>
                            </button>
                        </div>
                    </div>

                    <!-- Montant reçu -->
                    <div class="mb-6">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                            Montant reçu
                        </label>
                        <div class="relative">
                            <input v-model="reglementAmount"
                                   type="number"
                                   min="0"
                                   step="100"
                                   class="w-full pl-10 pr-4 py-4 text-2xl bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition text-right font-bold">
                            <i class="fas fa-money-bill absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
                        </div>

                        <!-- Suggestions -->
                        <div class="mt-3">
                            <p class="text-sm text-gray-600 dark:text-gray-400 mb-2">Suggestions :</p>
                            <div class="flex flex-wrap gap-2">
                                <button v-for="suggestion in getReglementSuggestions()" :key="suggestion"
                                        @click="reglementAmount = suggestion"
                                        class="px-4 py-2 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                                    {{ currencyFormatDE(suggestion) }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Reliquat -->
                    <div v-if="reglementAmount > 0"
                         class="mb-6 p-4 rounded-xl"
                         :class="calculateReliquat(reglementAmount) >= 0 ? 'bg-green-50 dark:bg-green-900/20' : 'bg-red-50 dark:bg-red-900/20'">
                        <div class="flex justify-between items-center">
              <span class="font-medium" :class="calculateReliquat(reglementAmount) >= 0 ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'">
                {{ calculateReliquat(reglementAmount) >= 0 ? 'Monnaie à rendre' : 'Montant manquant' }}
              </span>
                            <span class="text-xl font-bold" :class="calculateReliquat(reglementAmount) >= 0 ? 'text-green-600 dark:text-green-300' : 'text-red-600 dark:text-red-300'">
                {{ currencyFormatDE(Math.abs(calculateReliquat(reglementAmount))) }}
              </span>
                        </div>
                    </div>

                    <!-- Bouton validation -->
                    <button @click="applyReglement"
                            :disabled="!Items.jsonv.modereglement"
                            :class="[
                    'w-full py-4 rounded-xl font-bold text-lg transition-all duration-200',
                    Items.jsonv.modereglement
                      ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:opacity-90'
                      : 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                  ]">
                        Valider le paiement
                    </button>
                </div>
            </div>
        </div>

        <!-- Composants enfants -->
        <widgetserveur @selectserveur="selectserveur" ref="widgetserveur"></widgetserveur>
        <widgettable @selecttable="selecttable" ref="widgettable"></widgettable>
        <modalmodifierquantite ref="modalmodifierquantite" @updateqteitem="updateqteitem"></modalmodifierquantite>
        <modalfactureenattente ref="modalfactureenattente" @selectedfacture="updatefactureselected"></modalfactureenattente>
    </div>
</template>

<script>
    import { inject } from 'vue';
    const axios = require('axios');

    import {
        array_search,
        cloneobjet,
        currencyFormatDE,
        groupByKey, isset,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import { mapGetters } from "vuex";

    import modalmodifierquantite from "@/components/views/pages/caisse/facturation/modal_modifierquantite";
    import modalfactureenattente from "@/components/views/pages/caisse/facturation/2/modal_factureenattente";
    import widgetserveur from "@/components/views/pages/caisse/facturation/3/widgetfacturation/serveur";
    import widgettable from "@/components/views/pages/caisse/facturation/3/widgetfacturation/table";

    export default {
        /* eslint-disable */
        name: "FacturationRestaurant",

        watch: {
            searchword: function () {
                this.page = 1;
            },
            currentServer: function (newvalue) {
                if (Object.keys(newvalue).length > 0) {
                    this.Items.jsonv.collaborateur = newvalue;
                } else {
                    this.Items.jsonv.collaborateur = null;
                }
            },
        },

        computed: {
            ...mapGetters(['listedesarticlespourlacaisse', 'myscreenSize']),

            datatablearticlegroupe() {
                this.datatablearticle = cloneobjet(this.listedesarticlespourlacaisse);
                return groupByKey(this.listedesarticlespourlacaisse, 'catalogue');
            },

            nbrefactureenattante() {
                return this.datatable?.length || 0;
            },

            displayedPages() {
                const start = Math.max(1, this.page - 2);
                const end = Math.min(this.pages.length, start + 4);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            filterdatatable() {
                let mvalue = [];
                this.perPage = this.DefaultperPage;

                // Filtrer par catégorie
                if (this.selectedcatalogue !== '') {
                    for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {
                        if (index.toLowerCase() === this.selectedcatalogue.toLowerCase()) {
                            mvalue = [...mvalue, ...datavalue];
                        }
                    }
                } else {
                    for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {
                        mvalue = [...mvalue, ...datavalue];
                    }
                }

                // Filtrer par recherche
                if (this.searchword !== '') {
                    mvalue = mvalue.filter(post =>
                        post.libelle.toLowerCase().includes(this.searchword.toLowerCase())
                    );
                }

                return this.paginate(mvalue);
            },

            reliquat() {
                const total = parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                const recu = parseFloat(this.Items.jsonotherdonne.montantrecu) || 0;
                return recu - total;
            },

            filteredClients() {
                if (!this.clientSearch || !this.otherdatatable.beneficiairecl) {
                    return this.otherdatatable.beneficiairecl || [];
                }
                const search = this.clientSearch.toLowerCase();
                return this.otherdatatable.beneficiairecl.filter(client =>
                    client.name.toLowerCase().includes(search) ||
                    (client.phone && client.phone.includes(search)) ||
                    (client.ifu && client.ifu.toLowerCase().includes(search))
                );
            },
        },

        components: {
            modalmodifierquantite,
            modalfactureenattente,
            widgetserveur,
            widgettable,
        },

        data() {
            return {
                // États interface
                isDarkMode: true,
                quickMenuVisible: false,
                clientModalVisible: false,
                reglementModalVisible: false,

                // Données
                datatable: [],
                otherdatatable: {},
                datatablearticle: [],
                listedatatable: [],
                messagesucces: "",
                messageerror: "",
                compteprocess: 0,

                // Sélections
                currentServer: {},
                currentTable: {},
                selectedcatalogue: "",
                searchword: "",

                // Pagination
                page: 1,
                perPage: 100,
                DefaultperPage: 100,
                pages: [],

                // Forms
                ItemsArticle: {
                    accompagnement: [],
                    autredesignation: '',
                    mycheckkey: '',
                    docnum: '',
                    article: null,
                    qtite: 0,
                    pu: 0,
                    remise: 0,
                    mtnt: 0,
                    calmtntht: 0,
                    etatline: 0,
                    pid: '',
                    linekey: '',
                },

                Items: {
                    pid: '',
                    datedoc: '',
                    docnum: '',
                    jsonotherdonne: {
                        montantrecu: 0,
                        cltfrs: null,
                    },
                    jsonv: {
                        client: '',
                        ifu: '',
                        collaborateur: null,
                        modereglement: null,
                        commandetable: null,
                        isnormalisationetat: false,
                    },
                    mtnt: {
                        doccalmtnttotalht: 0,
                        docmtntremise: 0,
                        docmtnttotalttc: 0,
                    }
                },

                // Gestion clients
                clientSearch: "",
                newClient: {
                    name: "",
                    phone: "",
                    ifu: "",
                },

                // Gestion règlement
                reglementAmount: 0,

                // État normalisation
                isNormalisationEtat: false,
            };
        },

        methods: {



            async load(){

                var caisse={
                    cf:this.$store.state.caisseinfo,
                    document:"FV",
                }

                ///m/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/:pidcaisse/:keyuser/add895418init51comptoirerefdepdpcc11515/:ftoken

                // this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/load895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);
                let response =   axios  .post(url,caisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){

                            t.datatable=[];
                            t.datatable=res.data.m;

                        }
                        else{
                            t.datatable=[];


                        }


                    })
                    .catch((error)=>{

                            //  t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        // t.$store.dispatch('lancerchargement',false)


                    })




            },

            async loadreturnotherdata(){

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){
                            t.otherdatatable=[];
                            t.otherdatatable=res.data.otherdata;
                        }
                        else{
                            t.otherdatatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                //  }



            },

            async loadinputlibelleforms(){



                let $VALUEDATAPRICE=JwtService.getVALUEDATAPRICE()

                if (isset($VALUEDATAPRICE)){

                    this.datainputlibelleforms=JSON.parse($VALUEDATAPRICE);


                }
                else{
                    const t = this;
                    let url=process.env.VUE_APP_API_URL+'/12478855libelinputindex2iofdofiloadexp2/'+this.$store.state.appsociete+'/'+randomString();
                    let response =   axios  .get(url,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                    let res= await response
                        .then(function (res){
                            t.$store.dispatch('lancerchargement',false)


                            if(res.data.success){


                                t.datainputlibelleforms=[];

                                t.datainputlibelleforms=res.data.valuedataprice;

                                JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))


                            }
                            else{
                                t.datainputlibelleforms=[];

                            }


                        })
                        .catch((error)=>{

                                t.$store.dispatch('lancerchargement',false)
                            }
                        )
                        .finally(() =>{

                            t.$store.dispatch('lancerchargement',false)


                        })
                }



            },


            async loadInitialData() {
                try {
                    // Charger les produits
                    this.datatablearticle = cloneobjet(this.listedesarticlespourlacaisse || []);

                    // Charger les données supplémentaires
                    const response = await axios.get(
                        `${process.env.VUE_APP_API_URL}/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/${this.$store.state.appsociete}/${randomString()}`,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                            }
                        }
                    );

                    if (response.data.success) {
                        this.otherdatatable = response.data.otherdata;
                    }
                } catch (error) {
                    console.error('Erreur chargement initial:', error);
                    this.showToast('error', 'Erreur lors du chargement des données');
                }
            },

            setupKeyboardShortcuts() {
                this.keydownHandler = (event) => {
                    // Ctrl + F : Focus recherche
                    if (event.ctrlKey && event.key === 'f') {
                        event.preventDefault();
                        document.querySelector('input[placeholder*="Rechercher"]')?.focus();
                    }

                    // Ctrl + N : Nouvelle vente
                    if (event.ctrlKey && event.key === 'n') {
                        event.preventDefault();
                        this.newinvoice();
                    }

                    // Ctrl + S : Sauvegarder
                    if (event.ctrlKey && event.key === 's') {
                        event.preventDefault();
                        this.saveItems();
                    }

                    // Échap : Fermer les modals
                    if (event.key === 'Escape') {
                        this.clientModalVisible = false;
                        this.reglementModalVisible = false;
                        this.quickMenuVisible = false;
                    }
                };

                document.addEventListener('keydown', this.keydownHandler);
            },

            cleanupKeyboardShortcuts() {
                if (this.keydownHandler) {
                    document.removeEventListener('keydown', this.keydownHandler);
                }
            },
            // ========== INTERFACE ==========
            toggleTheme() {
                this.isDarkMode = !this.isDarkMode;
                this.isNormalisationEtat = !this.isDarkMode;
                this.Items.jsonv.isnormalisationetat = this.isNormalisationEtat;
            },

            toggleQuickMenu() {
                this.quickMenuVisible = !this.quickMenuVisible;
            },

            scrollToProducts() {
                const productsSection = document.querySelector('.lg\\:col-span-2');
                if (productsSection) {
                    productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            },

            clearCart() {
                if (this.listedatatable.length > 0 && confirm('Vider tout le panier ?')) {
                    this.listedatatable = [];
                    this.calcullistedatatable();
                }
            },

            // ========== GESTION SERVEUR/TABLE ==========
            selectserveur(serveur) {
                this.currentServer = serveur;
                this.Items.jsonv.collaborateur = serveur;
            },

            selecttable(table) {
                this.currentTable = table;
                this.Items.jsonv.commandetable = table;
            },

            btnwidgetserveur() {
                this.$refs.widgetserveur?.show(this.otherdatatable.collaborateur, this.currentServer);
            },

            btnwidgettable() {
                this.$refs.widgettable?.show([], this.currentTable);
            },

            // ========== GESTION CLIENTS ==========
            btnwidgetclient() {
                this.clientModalVisible = true;
                this.clientSearch = "";
            },

            openNewClientModal() {
                this.clientModalVisible = true;
                this.clientSearch = "";
                this.newClient = { name: "", phone: "", ifu: "" };
            },

            selectClient(client) {
                this.Items.jsonotherdonne.cltfrs = client;
                this.Items.jsonv.client = client.name;
                this.Items.jsonv.ifu = client.ifu || '';
                this.clientModalVisible = false;
            },

            async addNewClient() {
                if (!this.newClient.name.trim()) {
                    this.showToast('error', 'Le nom du client est obligatoire');
                    return;
                }

                try {
                    const newClient = {
                        id: randomString(10),
                        name: this.newClient.name.trim(),
                        phone: this.newClient.phone.trim(),
                        ifu: this.newClient.ifu.trim(),
                    };

                    if (!this.otherdatatable.beneficiairecl) {
                        this.otherdatatable.beneficiairecl = [];
                    }

                    this.otherdatatable.beneficiairecl.unshift(newClient);
                    this.selectClient(newClient);

                    this.newClient = { name: "", phone: "", ifu: "" };
                    this.showToast('success', 'Client ajouté avec succès');
                } catch (error) {
                    this.showToast('error', 'Erreur lors de l\'ajout du client');
                }
            },

            // ========== GESTION RÈGLEMENT ==========
            btnwidgetreglement() {
                this.reglementAmount = parseFloat(this.Items.jsonotherdonne.montantrecu) ||
                    parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                this.reglementModalVisible = true;
            },

            selectReglementMode(mode) {
                this.Items.jsonv.modereglement = mode;
            },

            getReglementIcon(modeName) {
                const icons = {
                    'Espèces': 'fas fa-money-bill-wave',
                    'Carte Bancaire': 'fas fa-credit-card',
                    'Chèque': 'fas fa-file-invoice-dollar',
                    'Virement': 'fas fa-exchange-alt',
                    'Mobile Money': 'fas fa-mobile-alt',
                    'Carte': 'fas fa-credit-card',
                };
                return icons[modeName] || 'fas fa-money-check-alt';
            },

            getReglementSuggestions() {
                const total = parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                if (total <= 0) return [];

                const suggestions = new Set();

                // Montant exact
                suggestions.add(Math.ceil(total));

                // Arrondis courants
                [1000, 2000, 5000, 10000, 20000].forEach(round => {
                    if (round >= total) suggestions.add(round);
                });

                // Arrondi au multiple de 1000 supérieur
                const roundedUp = Math.ceil(total / 1000) * 1000;
                if (roundedUp > total) suggestions.add(roundedUp);

                // Ajouter quelques montants supplémentaires
                if (roundedUp > total) {
                    suggestions.add(roundedUp + 1000);
                    suggestions.add(roundedUp + 2000);
                }

                return Array.from(suggestions).sort((a, b) => a - b);
            },

            calculateReliquat(amount) {
                const total = parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                return parseFloat(amount) - total;
            },

            applyReglement() {
                if (!this.Items.jsonv.modereglement) {
                    this.showToast('error', 'Veuillez sélectionner un mode de règlement');
                    return;
                }

                this.Items.jsonotherdonne.montantrecu = parseFloat(this.reglementAmount) || 0;
                this.reglementModalVisible = false;
                this.showToast('success', 'Mode de règlement appliqué');
            },

            // ========== GESTION PRODUITS ==========
            quickAddToCart(product) {
                if (!this.validatePrerequisites()) return;

                const existingItem = this.listedatatable.find(item =>
                    item.article.pid === product.pid && item.autredesignation === ''
                );

                if (existingItem) {
                    existingItem.qtite++;
                    this.updateItemInBackend(existingItem);
                } else {
                    this.addProductToCart(product);
                }
            },

            selectionitemforfacturation(product) {
                if (!this.validatePrerequisites()) return;

                const existingItem = this.listedatatable.find(item =>
                    item.article.pid === product.pid && item.autredesignation === ''
                );

                if (existingItem) {
                    this.$refs.modalmodifierquantite?.show(
                        cloneobjet(existingItem),
                        this.isNormalisationEtat,
                        'update'
                    );
                } else {
                    this.ItemsArticle = {
                        ...this.ItemsArticle,
                        mycheckkey: product.pid,
                        article: product,
                        qtite: 1,
                        pu: this.isNormalisationEtat ? product.pu7 : product.pu,
                        pid: '',
                        linekey: randomString(20),
                    };

                    this.$refs.modalmodifierquantite?.show(
                        cloneobjet(this.ItemsArticle),
                        this.isNormalisationEtat,
                        'add'
                    );
                }
            },

            validatePrerequisites() {
                if (!this.currentServer?.name) {
                    this.showToast('info', 'Veuillez sélectionner un serveur');
                    this.btnwidgetserveur();
                    return false;
                }

                if (!this.Items.jsonv.client) {
                    this.showToast('info', 'Veuillez sélectionner un client');
                    this.btnwidgetclient();
                    return false;
                }

                return true;
            },

            focusFirstProduct() {
                const firstProduct = document.querySelector('.cursor-pointer');
                if (firstProduct) {
                    firstProduct.focus();
                }
            },

            // ========== GESTION PANIER ==========
            btnupdateqteitem(item) {
                this.$refs.modalmodifierquantite?.show(
                    cloneobjet(item),
                    this.isNormalisationEtat,
                    'update'
                );
            },

            updateqteitem(data) {


                console.log("updateqteitem data  ********* ",data)

                const index = this.listedatatable.findIndex(item => item.linekey === data.item.linekey);
                console.log("updateqteitem index  ********* ",index)
                if (index !== -1) {
                    this.listedatatable[index] = data.item;
                    this.calcullistedatatable();
                    this.updateItemInBackend(data.item);
                }

                console.log("updateqteitem this.listedatatable  ********* ",this.listedatatable)

                /*this.ItemsArticle=$datavalue.item
                this.ItemsArticle.qtite=$datavalue.newqte
                this.ItemsArticle.mtnt=this.montant;*/






            },

            async SaveArticle(){

                this.searchword="";

                if (this.Items.jsonotherdonne.cltfrs===null ){


                    toastr['error']( 'Veuillez séléctionner un client',"<b></b>");
                    return
                }

                if (this.Items.jsonotherdonne.moderglt===null ){


                    toastr['error']( 'Veuillez séléctionner le mode de réglement',"<b></b>");
                    return
                }

                if (this.ItemsArticle.article===null)
                {

                    toastr['error']( 'Veuillez sélectionner un article valide',"<b></b>");
                    return

                }

                if (parseFloat(this.ItemsArticle.qtite)===0 ||  parseFloat(this.ItemsArticle.mtnt)===0  ||  parseFloat(this.ItemsArticle.pu)===0)
                {

                    toastr['error']( 'Veuillez saisir toutes les informations(la quantité ou le prix)',"<b></b>");
                    return

                }




                let vm=this,
                    linekey="",
                    newqtite=0,
                    $mtnt=0,
                    $remise=0,
                    oldqtite=0,
                    mitems,
                    t=this;


                if (t.ItemsArticle.linekey===""){
                    linekey= randomString(20);
                    t.ItemsArticle.linekey=linekey;
                    t.ItemsArticle.etatline=0
                    t.ItemsArticle.ppu=t.ItemsArticle.pu;
                    //t.ItemsArticle.pu=t.ItemsArticle.pu;
                    t.ItemsArticle.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                    mitems=cloneobjet(t.ItemsArticle);

                    t.listedatatable.push(mitems);

                }
                else{

                    linekey=t.ItemsArticle.linekey;
                    newqtite=t.ItemsArticle.qtite;

                    t.listedatatable.forEach(function (line) {

                        if (line.linekey===linekey){
                            line.etatline=0;
                            oldqtite=line.qtite;
                            line.qtite=newqtite;
                            line.ppu=t.ItemsArticle.pu;
                            line.pu=t.ItemsArticle.pu;
                            line.autredesignation=t.ItemsArticle.autredesignation
                            line.mtnt=t.ItemsArticle.mtnt
                            line.mtntclt=t.ItemsArticle.mtntclt
                            line.remise=t.ItemsArticle.remise
                            line.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                        }
                    })

                    mitems=cloneobjet(t.ItemsArticle);

                }

                t.newArticle();
                t.calcullistedatatable();
                t.compteprocess++; // compte le de process en cour

                mitems.cf=this.$store.state.caisseinfo;



                let url="",donneval={},response;

                if(t.Items.pid!==""){
                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/vline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,mitems,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }
                else{

                    this.$store.dispatch('lancerchargement',true)


                    t.Items.jsonotherdonne.tpdoc="facture"
                    t.Items.jsonotherdonne.tredocument="vente"
                    t.Items.cf=this.$store.state.caisseinfo
                    t.Items.jsonv.modereglement=t.Items.jsonotherdonne.moderglt
                    t.Items.jsonv.typ="VENC"
                    t.Items.jsonv.comptabilise=0

                    donneval={  'itemdoc':t.Items, 'itemArticle':mitems, }

                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/add895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,donneval,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");


                            t.compteprocess--;



                            if(t.Items.pid===""){

                                t.ItemsArticle.docnum=res.data.numdoc;
                                t.Items.docnum=res.data.numdoc;
                                t.Items.docpid=res.data.keypid;
                                t.ItemsArticle.docnum=res.data.keypid;
                                t.ItemsArticle.docpid=res.data.keypid;
                                t.Items.pid=res.data.keypid;

                            }

                            //  if (line.pid===""){line.pid=res.data.key;}

                            let $search=""

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=1;

                                    $search=line.article.pid

                                    if (line.pid===""){

                                        line.pid=res.data.keyline;
                                        line.docnum=res.data.keypid;
                                        line.docpid=res.data.keypid;

                                    }

                                }
                            })

                            let $checkindex=array_search($search,t.datatablearticle,'pid')

                            if ($checkindex>=0){


                                if (parseFloat(t.datatablearticle[$checkindex].instock)===1){
                                    t.datatablearticle[$checkindex].rstck=res.data.pk

                                    t.$store.commit('listedesarticlespourlacaisse', { value:t.datatablearticle });



                                }


                            }





                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                            t.compteprocess--;

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=2;


                                    line.linemessage="Une erreur c'est produite lors du traitement de l'opération." +
                                        " Veuillez réessayer l'opération. "+res.data.message;



                                }

                            })

                            t.calcullistedatatable();



                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");

                        t.compteprocess--;

                        t.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.etatline=2;
                                line.linemessage="Une erreur c'est produite lors du traitement de l'opération.Elle a échoué. Veuillez réessayer l'opération. ";

                            }

                        })

                        t.calcullistedatatable();


                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },

            async deleteItemArticle(item) {
                if (!confirm('Supprimer cet article du panier ?')) return;

                const index = this.listedatatable.findIndex(i => i.linekey === item.linekey);
                if (index !== -1) {
                    this.listedatatable.splice(index, 1);
                    this.calcullistedatatable();

                    if (item.pid) {
                        await this.deleteItemFromBackend(item);
                    }
                }
            },

            async addProductToCart(product) {
                try {
                    const item = {
                        linekey: randomString(20),
                        article: product,
                        qtite: 1,
                        pu: this.isNormalisationEtat ? product.pu7 : product.pu,
                        remise: 0,
                        mtnt: this.isNormalisationEtat ? product.pu7 : product.pu,
                        calmtntht: this.isNormalisationEtat ? product.pu7 : product.pu,
                        etatline: 0,
                        autredesignation: '',
                        mycheckkey: product.pid,
                    };

                    this.listedatatable.push(item);
                    this.calcullistedatatable();

                    // Enregistrer en backend si nécessaire
                    if (this.Items.pid) {
                        await this.saveItemToBackend(item);
                    }
                } catch (error) {
                    this.showToast('error', 'Erreur lors de l\'ajout du produit');
                }
            },

            // ========== CALCULS ==========
            calcullistedatatable() {
                let totalHT = 0;
                let totalRemise = 0;

                this.listedatatable.forEach(line => {
                    if (line.etatline === 0 || line.etatline === 1) {
                        const montant = parseFloat(line.calmtntht) || 0;
                        const remise = parseFloat(line.remise) || 0;
                        totalHT += montant;
                        totalRemise += remise;
                    }
                });

                this.Items.mtnt.doccalmtnttotalht = Math.round(totalHT + totalRemise);
                this.Items.mtnt.docmtntremise = Math.round(totalRemise);
                this.Items.mtnt.docmtnttotalttc = Math.round(totalHT);
            },

            // ========== VENTE ==========
            async saveItems() {
                // Validation
                if (this.listedatatable.length === 0) {
                    this.showToast('error', 'Le panier est vide');
                    return;
                }

                if (!this.currentServer?.name) {
                    this.showToast('error', 'Sélectionnez un serveur');
                    return;
                }

                if (!this.Items.jsonv.client) {
                    this.showToast('error', 'Sélectionnez un client');
                    return;
                }

                if (!this.Items.jsonv.modereglement) {
                    this.showToast('error', 'Sélectionnez un mode de règlement');
                    return;
                }

                const total = parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                const recu = parseFloat(this.Items.jsonotherdonne.montantrecu) || 0;

                if (recu < total && !confirm(`Le montant reçu (${this.currencyFormatDE(recu)}) est inférieur au total (${this.currencyFormatDE(total)}). Continuer ?`)) {
                    return;
                }

                this.compteprocess++;

                try {
                    const commandeData = {
                        cf: this.$store.state.caisseinfo,
                        items: this.listedatatable,
                        client: this.Items.jsonv.client,
                        serveur: this.currentServer,
                        table: this.currentTable,
                        modeReglement: this.Items.jsonv.modereglement,
                        montantRecu: this.Items.jsonotherdonne.montantrecu,
                        montantTotal: total,
                        isNormalisationEtat: this.isNormalisationEtat,
                    };

                    // Simuler l'enregistrement
                    await new Promise(resolve => setTimeout(resolve, 1000));

                    this.showToast('success', 'Vente enregistrée avec succès');
                    this.handleloadsoldecaisse();
                    this.newinvoice();

                } catch (error) {
                    this.showToast('error', 'Erreur lors de l\'enregistrement');
                    console.error(error);
                } finally {
                    this.compteprocess--;
                }
            },

            // ========== UTILITAIRES ==========
            formatNumber(num) {
                return currencyFormatDE(num);
            },

            currencyFormatDE(num) {
                return currencyFormatDE(Number(num) || 0);
            },

            getAmountSuggestions() {
                const total = parseFloat(this.Items.mtnt.docmtnttotalttc) || 0;
                if (total <= 0) return [];

                const suggestions = new Set();
                suggestions.add(total);

                [1000, 2000, 5000, 10000].forEach(round => {
                    if (round >= total) suggestions.add(round);
                });

                return Array.from(suggestions).sort((a, b) => a - b);
            },

            showToast(type, message) {
                const toasts = {
                    success: () => alert(`✅ ${message}`), // Remplacez par votre système de notifications
                    error: () => alert(`❌ ${message}`),
                    info: () => alert(`ℹ️ ${message}`),
                    warning: () => alert(`⚠️ ${message}`),
                };
                toasts[type]?.();
            },

            // ========== NAVIGATION ==========
            newinvoice() {
                this.listedatatable = [];
                this.Items = {
                    pid: '',
                    datedoc: this.$store.state.dateouverturecaisse,
                    docnum: '',
                    jsonotherdonne: {
                        montantrecu: 0,
                        cltfrs: this.Items.jsonotherdonne.cltfrs,
                    },
                    jsonv: {
                        client: this.Items.jsonv.client,
                        ifu: this.Items.jsonv.ifu,
                        collaborateur: this.currentServer,
                        modereglement: this.Items.jsonv.modereglement,
                        commandetable: this.currentTable,
                        isnormalisationetat: this.isNormalisationEtat,
                    },
                    mtnt: {
                        doccalmtnttotalht: 0,
                        docmtntremise: 0,
                        docmtnttotalttc: 0,
                    }
                };
                this.showToast('info', 'Nouvelle vente créée');
            },

            // ========== PAGINATION ==========
            setPages(posts) {
                this.pages = [];
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },

            paginate(posts) {
                this.setPages(posts);
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                return posts.slice(from, to);
            },

            // ========== MÉTHODES BACKEND (à adapter) ==========
            async updateItemInBackend(item) {
                // Implémentez l'appel API pour mettre à jour l'article
                console.log('Mise à jour article:', item);
            },

            async deleteItemFromBackend(item) {
                // Implémentez l'appel API pour supprimer l'article
                console.log('Suppression article:', item);
            },

            async saveItemToBackend(item) {
                // Implémentez l'appel API pour sauvegarder l'article
                console.log('Sauvegarde article:', item);
            },

            // ========== MÉTHODES EXISTANTES ==========
            btnupdatefactureselected() {
                this.$refs.modalfactureenattente?.show(this.datatable);
            },

            updatefactureselected(facture) {
                this.Items = facture.item;
                this.listedatatable = facture.lignes || [];
                this.calcullistedatatable();
            },

            note() {
                if (this.listedatatable.length === 0) {
                    this.showToast('error', 'Le panier est vide');
                    return;
                }

                // Logique d'impression de la note
                console.log('Impression note:', {
                    client: this.Items.jsonv.client,
                    total: this.Items.mtnt.docmtnttotalttc,
                    articles: this.listedatatable
                });

                this.showToast('success', 'Note imprimée');
            },

            btnmodalpointdelacaisse5() {
                // Logique pour afficher le point de caisse
                console.log('Point de caisse');
            },

            // ========== INJECTION PARENT ==========
            handleloadsoldecaisse() {
                const loadsoldecaisse = inject('loadsoldecaisse');
                if (loadsoldecaisse) loadsoldecaisse();
            },
        },

        async mounted() {
            // Initialisation
            this.Items.datedoc = this.$store.state.dateouverturecaisse || new Date().toISOString().split('T')[0];

            // Charger les données initiales
            //await this.loadInitialData();
            await this.load();
            await this.loadreturnotherdata();
            await this.loadinputlibelleforms();

            // Configurer les événements clavier
            this.setupKeyboardShortcuts();
        },

        beforeUnmount() {
            // Nettoyer les événements
            this.cleanupKeyboardShortcuts();
        },

        setup() {
            // Méthodes injectées
            const handlebtnreinitialiserAllarticle = inject('reinitialiserAllarticle');
            const handleloadsoldecaisse = inject('loadsoldecaisse');

            return {
                handlebtnreinitialiserAllarticle,
                handleloadsoldecaisse
            };
        },


    };
</script>

<style scoped>
    /* Styles pour le line-clamp */
    .line-clamp-1 {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .line-clamp-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    /* Animations */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    .slide-enter-active, .slide-leave-active {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .slide-enter-from, .slide-leave-to {
        transform: translateY(20px);
        opacity: 0;
    }

    .scale-enter-active, .scale-leave-active {
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .scale-enter-from, .scale-leave-to {
        transform: scale(0.95);
        opacity: 0;
    }

    /* Scrollbar personnalisée */
    .custom-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    .dark .custom-scrollbar::-webkit-scrollbar-track {
        background: #374151;
    }

    .dark .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #6b7280;
    }

    .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #9ca3af;
    }

    /* Effets de hover */
    .hover-lift {
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .hover-lift:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    }

    /* Responsive */
    @media (max-width: 640px) {
        .container {
            padding-left: 0.75rem;
            padding-right: 0.75rem;
        }

        .grid-cols-2 {
            grid-template-columns: repeat(2, 1fr) !important;
        }
    }

    @media (max-width: 768px) {
        .lg\:col-span-2 {
            grid-column: span 1;
        }

        .lg\:col-span-1 {
            grid-column: span 1;
        }
    }

    /* Transitions de thème */
    .theme-transition {
        transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
    }

    /* Styles pour les inputs */
    input:focus, select:focus, textarea:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
        ring-width: 2px;
    }

    /* Optimisation pour mobile */
    @media (hover: none) and (pointer: coarse) {
        button, [role="button"] {
            min-height: 44px;
            min-width: 44px;
        }

        input, select, textarea {
            font-size: 16px; /* Empêche le zoom sur iOS */
        }
    }

    /* Styles d'impression */
    @media print {
        .no-print {
            display: none !important;
        }
    }
</style>